// src/components/store/sections/newsletter/NewsletterV63CyberconsoleSlateGold.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV63CyberconsoleSlateGold(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={63}
      archKey="cyber_console"
      archLabel="Cyber Neon Console"
      palName="SlateGold"
      grad="from-slate-800 via-zinc-900 to-neutral-950"
      lightBg="bg-amber-50/80"
      textCol="text-amber-700"
      borderCol="border-amber-300"
      btnCls="bg-slate-900 hover:bg-slate-800"
      hexCol="#eab308"
      {...props}
    />
  );
}
